import React from "react";

interface LoginFormProps {
  onClose: () => void;
  password: string;
  showPassword: boolean;
  userName: string;
  onPasswordChange: (value: string) => void;
  onSubmit: (e?: React.FormEvent) => void | Promise<void>;
  onToggleRegister: () => void;
  onToggleShowPassword: () => void;
  onUserNameChange: (value: string) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  onClose,
  password,
  showPassword,
  userName,
  onPasswordChange,
  onSubmit,
  onToggleRegister,
  onToggleShowPassword,
  onUserNameChange,
}) => {
  const inputClassName =
    "w-full rounded-lg border-[0.69px] border-[#0072A3] bg-[#FFFFFF] md:px-3 px-1.5 md:py-2.5 py-1.5 md:mb-3 mb-1.5  font-mono text-lg font-medium text-[#0072A3] outline-none shadow-[inset_0px_-4px_8.4px_0px_#00AAFFD9] placeholder:text-[#0072A3]";

  return (
    <div className="fixed w-full h-full top-0 left-0 flex flex-col items-center justify-center bg-black/60">
      <div className="md:w-[630px] md:h-[480px] w-[425px] h-[380px] relative">
        {/* overlay */}
        <img
          className="absolute top-0 left-0 z-10"
          src="/assets/common/form-bg.png"
          alt="background"
        />
        {/* form */}

        <form
          onSubmit={onSubmit}
          className="absolute md:top-1/2 top-[45%] left-1/2 -translate-x-1/2 -translate-y-1/2  z-20 w-[80%]"
        >
          <div className="flex justify-center">
            <img
              className="z-20 w-[80%] md:w-full"
              src="/assets/common/text-login.png"
              alt="ĐĂNG NHẬP"
            />
          </div>

          <div className="md:mb-4 mb-1">
            <input
              type="text"
              value={userName}
              onChange={(e) => onUserNameChange(e.target.value)}
              placeholder="Nhập tên đăng nhập"
              maxLength={16}
              minLength={4}
              autoComplete="username"
              required
              className={inputClassName}
            />
          </div>

          <div className="mb-1 md:md-4">
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => onPasswordChange(e.target.value)}
                placeholder="Nhập mật khẩu"
                maxLength={16}
                minLength={4}
                autoComplete="current-password"
                required
                className={`${inputClassName} pr-9`}
              />
              <button
                type="button"
                onClick={onToggleShowPassword}
                className="absolute right-2.5 top-[40%] -translate-y-1/2 p-1 text-slate-500"
                aria-label={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {showPassword ? (
                    <>
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </>
                  ) : (
                    <>
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </>
                  )}
                </svg>
              </button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 md:mt-8 mt-1">
            <button className="flex items-center justify-center" type="submit">
              <img
                className="md:w-full w-[90%]"
                src="/assets/common/btn-accept.png"
                alt="Đăng nhập"
              />
            </button>
            <button
              className="flex items-center justify-center"
              type="button"
              onClick={onClose}
            >
              <img
                className="md:w-full w-[90%]"
                src="/assets/common/btn-cancel.png"
                alt="Đóng modal"
              />
            </button>
          </div>
          <div className="text-center md:mt-3 mt-1">
            <span className="text-xl font-bold text-white/90 mr-1">
              Chưa có tài khoản?
            </span>
            <span
              role="button"
              tabIndex={0}
              onClick={onToggleRegister}
              onKeyDown={(e) => e.key === "Enter" && onToggleRegister()}
              className="cursor-pointer text-xl font-bold text-yellow-400 underline"
            >
              Đăng ký ngay
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
